import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const cloudflareAnalyticsToken = process.env.REACT_APP_CLOUDFLARE_ANALYTICS_TOKEN;

if (cloudflareAnalyticsToken) {
  const analyticsScript = document.createElement('script');
  analyticsScript.defer = true;
  analyticsScript.src = 'https://static.cloudflareinsights.com/beacon.min.js';
  analyticsScript.dataset.cfBeacon = JSON.stringify({ token: cloudflareAnalyticsToken });
  document.head.appendChild(analyticsScript);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
